import {defaultFilter} from "@/servicios/productos/casFamily/state";

/**
 * cambia el estado para mostrar modal.
 *
 * @param show
 */
export function changeStateModalForm(state, show) {
    state.showModalForm = show;
}

/**
 * Setear información del payload
 *
 * @param show
 */
export function setPayloadForm(state, payloadForm) {
    state.payloadForm = structuredClone(payloadForm);
}

/**
 * Listar familias.
 *
 * @param casFamilies
 */
export function setCasFamilies(state, casFamilies) {
    state.casFamilies = casFamilies;
}

/**
 * Establece el filtro de familias por defecto.
 *
 * @return {void}
 */
export function setDefaultFilter(state) {
    state.filter = defaultFilter();
}

/**
 * Actualizar la cantidad de items a mostrar en la tabla.
 *
 */
export function updatePerPage(state, per_page) {
    state.filter.per_page = per_page
}


/**
 * Agregar familias activas
 *
 * @param listFamilies
 */
export function setListFamilies(state, listFamilies) {
    state.listFamilies = listFamilies;
}



/**
 * cambia el estado para mostrar modal de componentes asociados a una familia.
 *
 * @param show
 */
export function changeStateModalComponents(state, show) {
    state.showModalComponents= show;
}


/**
 * cambia el estado para mostrar modal del cambio de estado de una familia
 *
 * @param show
 */
export function changeStateModalChangeStatus(state, show) {
    state.showModalChangeStatus= show;
}
